import { AnyAction, isRejected } from '@reduxjs/toolkit';

import { TFARejectedAction } from '../types';
import { isTFAError } from './isTFAError';

export const isTFARejectedAction = (
  action: AnyAction,
): action is TFARejectedAction =>
  isRejected(action) && isTFAError(action.payload);
